import $ from 'jquery';
import BaseComponent from './baseComponent';

/**
 * Override stuff from the Drupal Webform / Drupal Form
 */
export default class ImageCaption extends BaseComponent {
  /**
     * Public constructor
     *
     * @param options
     */
  constructor(options) {
    super(options);

    this.imageIdentifier = options.imageIdentifier || null;
    this.captionIdentifier = options.captionIdentifier || null;

    return this;
  }

  /**
     * Set the correct distance to the image-on-hover of the caption
     *
     * @param $image
     * @param $caption
     */
  updateCaptionDistance($image, $caption) { // eslint-disable-line class-methods-use-this
    const height = $image.height();
    const scaledHeight = height * 1.05; // Value comes from vfx/transitions/_zoom.scss
    const translateValue = Math.floor((scaledHeight - height) / 2, 0);
    $caption.attr('data-vfx-scale-factor', translateValue);
    $image.on('mouseenter', () => {
      $caption.css('transform', `translateY(${translateValue}px)`);
    });
    $image.on('mouseleave', () => {
      $caption.css('transform', 'translateY(0px)');
    });
  }

  setImageCaptionDistance() {
    const $images = $(this.imageIdentifier);

    $.each($images, (index, image) => {
      const $image = $(image);
      const $caption = $image.next(this.captionIdentifier);

      // handle images / captions
      if ($caption.length > 0) {
        this.updateCaptionDistance($image, $caption);
      }
    });
  }

  /**
     * Initialize function
     */
  init() {
    this.setImageCaptionDistance();
  }

  updateOnResize() {
    this.setImageCaptionDistance();
  }
}
